export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4769.0e9b64e3.jpg";